import { Routes, Route } from "react-router-dom";

import Home from "../Views/Home";
import Contact from "../Views/Contact";

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}
